import { render } from "./DistrictsList.vue?vue&type=template&id=3dc9b789"
import script from "./DistrictsList.vue?vue&type=script&lang=js"
export * from "./DistrictsList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\investmap\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__